/* ───────── GraphQL Queries & Mutations ───────── */

// Huvud-MENU_QUERY: alltid anon-tillgänglig. Kioskens till-konfiguration
// hämtas separat efter inloggning via TILL_QUERY.
export const MENU_QUERY = `query($id: ID!, $menuType: MenuType!) {
  restaurant(id: $id) {
    name
    showsTipInClient
    queueTime
    paymentMethods { id name paymentProvider }
    deliveryLocations(menuType: $menuType) { id name eatInEnabled takeAwayEnabled }
    deliveryTimeSlots(menuType: $menuType) { id deadline disabled label value }
    menu { pages { id name categories { id name description products { id name ingredientsTextSv ingredientsTextEn allergens
      energyKcal fatMg saturatedFatMg carbohydratesMg sugarsMg proteinMg saltMg fiberMg
      properties(menuType: $menuType) {
        id stateId price preCampaignPrice description imageUrl isActive temporarilyDisabled vatRatePercentage
        openingHours { name productVisibility periods { open { day time } close { day time } } }
        alternativeGroups { id name forceChoice isCountable minChoices maxChoices
          alternativeItems { name isDefault countableUsage addonProduct { id name properties(menuType: $menuType) { id stateId price isActive imageUrl description } } }
        }
      }
    } } } }
  }
}`

export const TERMS_QUERY = `{ currentTermsOfService { id url } }`

export const ACCEPT_TERMS = `mutation($id: ID!) { acceptTermsOfService(id: $id) }`

export const CREATE_ORDER_INTENT = `mutation($rid: ID!, $input: OrderIntentInput!) {
  createOrderIntent(restaurantId: $rid, input: $input) {
    id state totalAmountPayable vatAmountPayable finalizeAccessToken
  }
}`

export const CREATE_PAYMENT_INTENT = `mutation($oid: ID!, $input: PaymentIntentInput!) {
  createPaymentIntent(orderIntentId: $oid, input: $input) {
    id state finalizeAccessToken
    action { type stripeClientSecret qrCodeValue statusUrl deadline }
  }
}`

export const FINALIZE_PAYMENT = `mutation($pid: ID!, $t: String) {
  finalizePaymentIntent(paymentIntentId: $pid, accessToken: $t) { id state }
}`

export const CANCEL_PAYMENT = `mutation($pid: ID!) {
  cancelPaymentIntent(paymentIntentId: $pid) { id state }
}`

export const CANCEL_ORDER = `mutation($rid: ID!, $oid: ID!) {
  cancelOrderIntent(restaurantId: $rid, orderIntentId: $oid, input: {}) { id state }
}`

export const FINALIZE_ORDER = `mutation($oid: ID!) {
  finalizeOrderIntent(orderIntentId: $oid) {
    id receiptViewKey
    receiptPrinter { id name }
  }
}`

export const RECEIPT_QUERY = `query($oid: ID!, $vk: String!) {
  receipt(orderId: $oid, viewKey: $vk) { html }
}`

export const ME_QUERY = `{ me { id } }`

export const TILL_QUERY = `query($restaurantId: ID!, $tillId: ID!) {
  restaurant(id: $restaurantId) {
    till(id: $tillId) {
      id name showsStripeSwish showsTip showsMenuType
      paymentMethods { id name paymentProvider }
      posTerminals { id name isOnline isActive paymentProvider }
      receiptPrinterQueue { id name physicalPrinters { id name isOnline } }
      sendOrderToKitchen
      fixedDeliveryLocation { id eatInEnabled takeAwayEnabled }
      # Theme
      colorAccent: attribute(key: "galaga.theme.colorAccent")
      colorAccentHover: attribute(key: "galaga.theme.colorAccentHover")
      colorBg: attribute(key: "galaga.theme.colorBg")
      colorSurface: attribute(key: "galaga.theme.colorSurface")
      colorSurface2: attribute(key: "galaga.theme.colorSurface2")
      colorText: attribute(key: "galaga.theme.colorText")
      colorMuted: attribute(key: "galaga.theme.colorMuted")
      # Branding
      logoUrl: attribute(key: "galaga.branding.logoUrl")
      pageTitle: attribute(key: "galaga.branding.pageTitle")
      appName: attribute(key: "galaga.branding.appName")
      startScreenMedia: attribute(key: "galaga.branding.startScreenMedia")
      # PWA
      appIconUrl192: attribute(key: "galaga.pwa.iconUrl192")
      appIconUrl512: attribute(key: "galaga.pwa.iconUrl512")
      pwaThemeColor: attribute(key: "galaga.pwa.themeColor")
      # Layout
      layoutMode: attribute(key: "galaga.layout.mode")
      categoryNavStyle: attribute(key: "galaga.layout.categoryNavStyle")
      defaultProductLayout: attribute(key: "galaga.layout.defaultProductLayout")
      categoryColumns: attribute(key: "galaga.layout.categoryColumns")
      skipCategoryGrid: attribute(key: "galaga.layout.skipCategoryGrid")
      fullMenuCategoryBar: attribute(key: "galaga.layout.fullMenuCategoryBar")
      fullMenuCategoryBarAlign: attribute(key: "galaga.layout.fullMenuCategoryBarAlign")
      # Collapse
      collapseEnabled: attribute(key: "galaga.collapse.enabled")
      maxCollapsedRows: attribute(key: "galaga.collapse.maxRows")
      # Timeouts
      inactivityTimeout: attribute(key: "galaga.timeouts.inactivity")
      countdownDuration: attribute(key: "galaga.timeouts.countdown")
      receiptAutoDismiss: attribute(key: "galaga.timeouts.receiptAutoDismiss")
      # Tips
      tipsEnabled: attribute(key: "galaga.tips.enabled")
      tipPercentages: attribute(key: "galaga.tips.percentages")
      # Locale
      defaultLocale: attribute(key: "galaga.locale.default")
      availableLocales: attribute(key: "galaga.locale.available")

    }
  }
}`

export const CREATE_ACCESS_TOKEN = `mutation($username: String!, $password: String!) {
  createAccessToken(username: $username, password: $password) { parseToken }
}`
